// extracted by mini-css-extract-plugin
export var container = "_pv-0";
export var dotAnimation = "_pv-2";
export var dotsLoading = "_pv-1";